// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './FirstPage.css';
// import axios from 'axios';

// const FirstPage = () => {
//   const navigate = useNavigate();
//   const [profile, setProfile] = useState(null);

//   // Microsoft OAuth configuration
//   const clientId = process.env.REACT_APP_CLIENT_ID;
//   const tenantId = process.env.REACT_APP_TENANT_ID;
//   const redirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URI);
//   const backendUrl = process.env.REACT_APP_BACKEND_URL;
//   const scope = encodeURIComponent(process.env.REACT_APP_BACKEND_SCOPE);

//   const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query&scope=${scope}`;

//   // Extract query parameters
//   // const code = new URLSearchParams(window.location.search).get('code');
//   // const state = new URLSearchParams(window.location.search).get('state');
//   // const iss = new URLSearchParams(window.location.search).get('iss');

//   // useEffect(() => {
//   //   const IdpVerify = async () => {
//   //     if (!code || !state || !iss) {
//   //       console.log('Missing required parameters for authentication.');
//   //       return;
//   //     }

//   //     const params = new URLSearchParams();
//   //     params.append('code', code);
//   //     params.append('state', state);
//   //     params.append('iss', iss);

//   //     try {
//   //       // Exchange code for token with backend
//   //       const response = await axios.post(
//   //         `${process.env.REACT_APP_SERVER ?? window.location.origin}/api/demoapi`,
//   //         params,
//   //         {
//   //           headers: {
//   //             'Content-Type': 'application/x-www-form-urlencoded',
//   //           },
//   //           withCredentials: true,
//   //         }
//   //       );

//   //       if (response.status === 200) {
//   //         localStorage.setItem('token', response.data.token);
//   //         setProfile(response.data.profile); // Assuming profile data is returned

//   //         // Clear query parameters from URL
//   //         window.history.replaceState({}, document.title, window.location.pathname);

//   //         // Navigate based on role
//   //         const token = localStorage.getItem('token');
//   //         if (token) {
//   //           if (response.data.role === 'admin') {
//   //             navigate('/hrms/admindashboard');
//   //           } else {
//   //             navigate('/hrms/dashboard');
//   //           }
//   //         } else {
//   //           console.log('Token not found in localStorage.');
//   //         }
//   //       }
//   //     } catch (error) {
//   //       console.error('Authentication failed:', error.message);
//   //     }
//   //   };

//   //   IdpVerify();
//   // }, [code, state, iss, navigate]);

//   const handleLogin = () => {
//     window.location.href = authUrl; 
//   };

//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     // console.log("URLSearchParams:",params.toString());
//     const code = params.get('code');
//     const state = params.get('session_state');
//     // console.log("Code:",code,"State:",state);
//     if (code) {
//       axios
//         .post(`${backendUrl}/api/token`, { code, state })
//         .then((res) => {
//           // console.log('✅ Profile:', res.data.profile);
//           setProfile(res.data.profile);
//           localStorage.setItem('token', res.data.token);
//           window.history.replaceState({}, document.title, window.location.pathname);
//           const token = localStorage.getItem('token');
//           if (token) {
//             // if (res.data.role === 'admin') {
//               navigate('/admindashboard');
//             // } else {
//             //   navigate('/hrms/dashboard');
//             // }
//           } else {
//             console.log('Token not found in localStorage.');
//           }

//         })
//         .catch((err) => {
//           console.log('❌ Login failed:', err.response?.data || err.message);
//         });
//     }

//   }, [backendUrl]);

//   const handleLogout = () => {
//     setProfile(null);
//     localStorage.removeItem('token'); 

//     const postLogoutRedirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URI);
//     const logoutUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/logout?post_logout_redirect_uri=${postLogoutRedirectUri}`;

//     window.location.href = logoutUrl; 
//   };

//   return (
//     <div className="bodys">
//       <div className="intro-container">
//         <h1>HRMS</h1>
//         {profile ? (
//           <div>
//             <h2>Welcome, {profile.displayName}</h2>
//             <p>Email: {profile.mail || profile.userPrincipalName}</p>
//             <button onClick={handleLogout}>Logout</button>
//           </div>
//         ) : (
//           <div>
//             <button onClick={handleLogin}>Get Started with Microsoft</button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default FirstPage;




import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom'; // Add Navigate if not present
import './FirstPage.css';
import axiosInstance from './utills/axiosInstance';
import { attemptRefresh } from './utills/RefreshTimer'; // Import shared utils (if using)

const FirstPage = ({ isAuthenticated }) => { // Accept prop from App (if using global auth)
  const navigate = useNavigate();
  const location = useLocation();
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // Add for local loading (prevents flicker)

  const clientId = process.env.REACT_APP_CLIENT_ID;
  const tenantId = process.env.REACT_APP_TENANT_ID;
  const redirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URI);
  const scope = encodeURIComponent('https://graph.microsoft.com/User.Read openid profile email offline_access');

  const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query&scope=${scope}`;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || profile) return;

    const fetchProfile = async () => {
      setIsLoading(true);
      try {
        const res = await axiosInstance.get("/auth/user");
        setProfile(res.data);
        navigate('/dashboard');
        console.log("Profile loaded from /auth/user:", res.data);
      } catch (err) {
        console.warn("Failed to fetch profile:", err.response?.data);
        if (err.response?.status === 401) {
          const refreshed = await attemptRefresh();
          if (refreshed) {
            const retryRes = await axiosInstance.get("/auth/user");
            setProfile(retryRes.data);
            navigate('/dashboard');
            console.log("Profile loaded after refresh:", retryRes.data);
          } else {
            localStorage.removeItem("token");
            localStorage.removeItem('profile');
            localStorage.removeItem('data');
            setError("Session expired. Please log in again.");
          }
        } else if (err.response?.status === 403) {
          setError("Access denied. User not registered. Please contact admin.");
          localStorage.removeItem("token");
          localStorage.removeItem('profile');
          localStorage.removeItem('data');
        } else {
          setError("Failed to load profile. Please try again.");
          localStorage.removeItem("token");
          localStorage.removeItem('profile');
          localStorage.removeItem('data');
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfile();
  }, [navigate]);

  useEffect(() => {
    if (location.state?.error) {
      setError(location.state.error);
    }
  }, [location.state]);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleLogin = () => {
    window.location.href = authUrl;
  };

  const handleLogout = async () => {
    setProfile(null);
    localStorage.removeItem('token');
    localStorage.removeItem('profile');
    localStorage.removeItem('data');

    try {
      await axiosInstance.post('/auth/logout', {});
    } catch (logoutErr) {
      console.warn('Logout API failed (non-fatal):', logoutErr);
    }

    const postLogoutRedirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URI);
    const logoutUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/logout?post_logout_redirect_uri=${postLogoutRedirectUri}`;
    window.location.href = logoutUrl;
  };

  return (
    <div className="bodys">
      <div className="intro-container">
        <h1>HRMS</h1>
        {error && <p className="error">{error}</p>}
        {isLoading && <p>Validating session...</p>}
        {profile ? (
          <div>
            <h2>Welcome, {profile.displayName || profile.firstName}</h2>
            <p>Email: {profile.mail || profile.email}</p>
            <button className='first-button' onClick={handleLogout}>Logout</button>
          </div>
        ) : (
          <div>
            <button className='first-button' onClick={handleLogin}>Get Started with Microsoft</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FirstPage;
